import { BookingDetailsRecep } from "../../components/Layouts/BookingVehicleInfoCard/BookingDetailsRecep";
import React, { useEffect, useState } from "react";
import BookingGetters from "../../store/onlineBooking/getters";
import { AllPaymentMethodsResponse } from "../../@types/DTO/AllPaymentMethods";
import { BookingSubmitFooter } from "../../components/Layouts/BookingForm/BookingSubmitFooter";
import Recep from "../chooseVehicle/Recep";
import { ChosenOptions } from "../../components/Layouts/BookingVehicleInfoCard/BookingVehicleInfoCard.props";
import CollapseNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
const renderNavbar = (isSmallScreen, isDrawerOpen, setIsDrawerOpen) =>
  !isSmallScreen && (
    <CollapseNavbar
      isDrawerOpen={isDrawerOpen}
      toggleDrawer={setIsDrawerOpen}
    />
  );
const renderFooter = (props) => <BookingSubmitFooter {...props} />;
function PaymentPage({ offsetFromTop, divRef, isSmallScreen }) {
  const selectedVehicle = BookingGetters.getSelectedVehicleDetails();
  const payments = BookingGetters.getPaymentInfo();
  const isDesktopScreen = window.innerWidth >= 1220;
  const [allPaymentMethods, setAllPaymentMethods] = useState<
    Partial<AllPaymentMethodsResponse> | undefined
  >({});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("paypal");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const selectedFields = selectedVehicle?.paymentDetails;
  const [selectedExtras, setSelectedFields] = useState<ChosenOptions>({
    options: {},
    insurance: undefined,
  });
  useEffect(() => setAllPaymentMethods(payments), [payments]);
  useEffect(() => {
    setSelectedFields({
      options: selectedVehicle?.paymentDetails.addedExtraOptions || {},
      insurance: selectedVehicle?.paymentDetails.selectedInsurance,
    });
  }, [selectedVehicle]);
  return (
    <div className="flex flex-col box-border w-full">
      {renderNavbar(isSmallScreen, isDrawerOpen, setIsDrawerOpen)}
      <Recep
        activeStep={6}
        selectedVehicle={selectedVehicle?.vehicleDetails}
        selectedFields={selectedExtras}
        vehiclePrice={selectedFields.price}
        insurancePrice={selectedFields?.selectedInsurance?.price}
        onlyExtrasPrice={selectedFields?.extrasPrice}
        totalPrice={selectedFields.price}
        isPaymentPage={false}
        divRef={divRef}
        offsetFromTop={offsetFromTop}
      />
      <div className="h-full w-full animate__animated animate__slideInUp">
        <div
          style={
            isDesktopScreen
              ? {
                  marginTop: "64px",
                  marginLeft: "140px",
                  marginRight: "140px",
                  marginBottom: "152px",
                }
              : {}
          }
        >
          <BookingDetailsRecep
            allPaymentMethods={allPaymentMethods}
            selectedFields={selectedExtras}
            selectedPaymentMethod={selectedPaymentMethod}
            updatePaymentMethod={setSelectedPaymentMethod}
            isPrivacyPolicyChecked={true}
            isTermsCondnChecked={true}
          />
        </div>
        {renderFooter({
          selectedPaymentMethod,
          allPaymentMethods,
          isPaymentPage: "true",
        })}
      </div>
    </div>
  );
}
export default PaymentPage;
